import TableServicesCandidatesContainer from './TableServicesCandidates.container';
export default TableServicesCandidatesContainer;
